module.exports = __webpack_public_path__ + "img/ky.20d6577.svg";